export const containerStyles = { display: 'flex', flexDirection: 'column', gap: 2, p: 2 };
